import React from 'react';
import ElevioProvider from 'elevio/lib/react';

import { ActiveStore } from 'ggApp/modules/store/selectors';
import loadConfiguration from 'ggApp/utils/configuration';

const { ELEVIO_ACCOUNT_ID } = loadConfiguration();

const Elevio = ({ activeStore }: { activeStore: ActiveStore }) => {
    const { activeLanguage } = activeStore;

    return (
        <ElevioProvider
            accountId={ELEVIO_ACCOUNT_ID}
            language={activeLanguage}
            settings={{
                hideLauncher: true,
                articleFeedbackEnabled: false,
            }}
        />
    );
};

export default Elevio;
